import getCoord from './get-coord';
const throttle = require('lodash/throttle');

export default {
    init: initDrag,
    destroy: destroyDrag,
    disable: disable,
    enable: enable,
    disableDrag: disableDrag,
    enableDrag: enableDrag,
};

const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

let drags = [];
const noop = function () {
};

function disableDrag(elem) {
    var draggable = findByElem(elem);
    if (draggable) {
        draggable.disabledDrag = true;
    }
}

function enableDrag(elem) {
    let draggable = findByElem(elem);
    if (draggable) {
        draggable.disabledDrag = false;
    }
}

function disable(elem) {
    let draggable = findByElem(elem);
    if (draggable) {
        draggable.disabled = true;
    }
}

function enable(elem) {
    let draggable = findByElem(elem);
    if (draggable) {
        draggable.disabled = false;
    }
}

function findByElem(elem) {
    return drags.find(s => s.elem === elem);
}

function initDrag(elem, onDragStart, onDragMove, onDragEnd, onTap, options = {}, onMouseDown =() => Promise.resolve(), checkAccessForMovement) {
    if (elem.classList.contains('e3-draggable')) {
        return;
    }
    let resDrag = {};
    let onMove = onPanMove.bind(null, resDrag);
    elem.classList.add('e3-draggable');
    resDrag.elem = elem;
    resDrag.threshold = typeof options.threshold === 'undefined' || options.threshold === 'default' ? 8 : options.threshold;
    resDrag.onStart = onPanStart.bind(null, resDrag);
    resDrag.onMove = throttle(onMove, isFirefox ? 30 : 15);
    resDrag.onEnd = onPanEnd.bind(null, resDrag);
    resDrag.onTap = onTap;
    resDrag.callbacks = {
        start: onDragStart || noop,
        move: onDragMove || noop,
        end: onDragEnd || noop,
        check: checkAccessForMovement || Promise.resolve.bind(Promise)
};
    elem.addEventListener('mousedown', (e) => {
        onMouseDown()
            .then(() => {
                resDrag.onStart(e);
            }).catch((e) =>{
                console.error(e)
            });
    }, true);
    elem.addEventListener('touchstart', (e) => {
        onMouseDown()
            .then(() => {
                resDrag.onStart(e);
            }).catch((e) =>{
                console.error(e)
            });
    }, {passive: false});
    drags.push(resDrag);
}


function destroyDrag(elem) {
    let draggable = drags.filter(function (s) {
        return s.elem === elem
    })[0];
    if (!draggable) {
        return;
    }
    elem.removeEventListener('mousedown', draggable.onStart, true);
    elem.removeEventListener('touchstart', draggable.onStart, {passive: false});
    document.removeEventListener('mousemove', draggable.onMove, {capture: true, passive: true});
    document.removeEventListener('touchmove', draggable.onMove, {capture: false, passive: false});
    document.removeEventListener('mouseup', draggable.onEnd, true);
    document.removeEventListener('touchend', draggable.onEnd, true);
    elem.classList.remove('e3-draggable');
    drags.splice(drags.indexOf(draggable), 1);
}

function onPanStart(draggable, e) {
    if (draggable.disabled || draggable.status === 'move') return;
    let elem = draggable.elem;
    let rect = elem.getBoundingClientRect();
    draggable.startX = getCoord(e, 'pageX');
    draggable.startY = getCoord(e, 'pageY');
    let scale = parseFloat(elem.dataset.scale) || 1;
    draggable.radius = rect.width / 2;
    draggable.offsetX = getCoord(e, 'offsetX') * scale;
    draggable.offsetY = getCoord(e, 'offsetY') * scale;
    if (typeof draggable.offsetX === 'undefined' || Number.isNaN(draggable.offsetX)) {
        draggable.offsetX = draggable.startX - (rect.left + rect.width / 2);
        draggable.offsetY = draggable.startY - (rect.top + rect.height / 2);
    }
    else {
        draggable.offsetX -= draggable.radius;
        draggable.offsetY -= draggable.radius;
    }
    draggable.status = 'start';
    draggable.moveConfirmed = false;
    draggable.moving = true;
    elem.classList.add('dragging');
    document.addEventListener('mousemove', draggable.onMove, {capture: true, passive: true});
    document.addEventListener('touchmove', draggable.onMove, {capture: false, passive: false});
    document.addEventListener('mouseup', draggable.onEnd, true);
    document.addEventListener('touchend', draggable.onEnd, true);
}

function onPanMove(draggable, e) {
    let pageX, pageY, deltaX, deltaY;
    if (e.type !== 'mousemove' && e.preventDefault && e.stopPropagation){
        e.preventDefault();
        e.stopPropagation();
    }
    if (draggable.moving) {
        pageX = getCoord(e, 'pageX');
        pageY = getCoord(e, 'pageY');
        deltaX = pageX - draggable.startX;
        deltaY = pageY - draggable.startY;
        let dist = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        pageX -= draggable.offsetX;
        pageY -= draggable.offsetY;

        if(draggable.status === 'end') return [pageX, pageY];
        if (!draggable.disabledDrag && (draggable.moveConfirmed || dist > draggable.threshold)) {
            if (!draggable.moveConfirmed) {
                draggable.callbacks.start(draggable.elem);
                draggable.status = 'move';
                draggable.moveConfirmed = true;
                draggable.elem.addEventListener('click', prevent);
            }
            draggable.callbacks.move(draggable.elem, pageX, pageY, deltaX, deltaY);
        }
    }
    return [pageX, pageY];
}

function prevent(e) {
    e.preventDefault();
    e.stopPropagation();
}

function onPanEnd(draggable, e) {
    document.removeEventListener('mousemove', draggable.onMove, {capture: true, passive: true});
    document.removeEventListener('touchmove', draggable.onMove, {capture: false, passive: false});
    document.removeEventListener('mouseup', draggable.onEnd, true);
    document.removeEventListener('touchend', draggable.onEnd, true);
    draggable.elem.removeEventListener('click', prevent);
    draggable.status = 'end';
    if (!draggable.moveConfirmed) {
        draggable.onTap(e);
        return;
    }
    draggable.callbacks.check()
        .then(() => {
            draggable.moveConfirmed = false;
            let coords = onPanMove(draggable, e);
            draggable.startX = null;
            draggable.startY = null;
            draggable.moving = false;
            // draggable.elem.removeEventListener('click', prevent);
            draggable.callbacks.end(draggable.elem, coords[0], coords[1]);
        })
        .catch((e) => {
            draggable.moveConfirmed = false;
            let coords = onPanMove(draggable, e);
            let startX = draggable.startX;
            let startY = draggable.startY;
            draggable.startX = null;
            draggable.startY = null;
            draggable.moving = false;
            draggable.callbacks.end(draggable.elem, startX, startY);
            console.error(e);

            return;
        })

}
